import { UserReportFilter } from "@/types/reports";

/**
 * Builds a query string from user report filter form data
 * Handles array parameters by appending multiple values for the same key
 */
export function buildUserReportQueryString(formData: UserReportFilter): string {
  const params = new URLSearchParams();

  // Handle array parameters
  if (formData.userStatuses?.length) {
    formData.userStatuses.forEach((status) =>
      params.append("userStatuses", status),
    );
  }

  if (formData.seniorityLevels?.length) {
    formData.seniorityLevels.forEach((level) =>
      params.append("seniorityLevels", level),
    );
  }

  if (formData.positionIds?.length) {
    formData.positionIds.forEach((id) => params.append("positionIds", id));
  }

  if (formData.shirtSizes?.length) {
    formData.shirtSizes.forEach((size) => params.append("shirtSizes", size));
  }

  if (formData.cities?.length) {
    formData.cities.forEach((city) => params.append("cities", city));
  }

  // Handle single value parameters
  const singleValueFields: (keyof UserReportFilter)[] = [
    "nameSearch",
    "emailSearch",
    "taxDocumentsSigned",
    "badgeReceived",
    "receivedShirt",
    "bilingual",
  ];

  singleValueFields.forEach((field) => {
    const value = formData[field];
    if (value !== null && value !== undefined && value !== "") {
      params.append(field, String(value));
    }
  });

  return params.toString();
}
